export async function requestPre(config, next) {
    config.useNativeRequest = false;
    await next();
}
export async function requestSet(config, next) {
    await next();
}
